import { isProduction } from '../utils/common';

export const CMS_CDN = process.env.NEXT_PUBLIC_CMS_CDN_BASE_URL as string;

export const googleTagManagerId = process.env.NEXT_PUBLIC_GTM_ID?.trim();

// GTM은 프로덕션에서만, 그리고 컨테이너 ID 형식이 유효할 때만 로드한다.
export const shouldLoadGoogleTagManager =
  isProduction &&
  Boolean(googleTagManagerId) &&
  /^GTM-[A-Z0-9]+$/.test(googleTagManagerId ?? '');
